import { ApolloListQuery } from 'core/types/ApolloListQuery';
import { logger } from 'core/utils/logger';

export const extractQueryListItems = <T>(list: ApolloListQuery<T>) => {
  if (!list) {
    logger.error(
      'GraphQL query returned undefined. This typically means the query failed or the response structure is invalid.'
    );
    return [];
  }

  const firstValue = Object.values(list)[0];
  if (!firstValue) {
    logger.error(
      'GraphQL query returned null for the requested field. Check if the field exists in your schema and you have the correct permissions.'
    );
    return [];
  }
  const items = firstValue.items;

  // NOTE: It is possible for nulls to come back in from a list in GraphQL
  // This happens when querying a list where the schema doesn't align, normally based on bad data.
  // This util function will remove any nulls from a list.
  // The count may be off due to this, but it is better than having nulls in the list.
  return extractListItems(items);
};

export const extractListItems = <T>(list: T[]) => {
  return list.filter(
    (item) => item !== null && item !== undefined
  ) as NonNullable<T>[];
};
